import { Building2, User, Users } from 'lucide-react';

import {
  ehCooperativa,
  naturezaDaPessoa,
  rotuloDoTipoDeCredenciado,
  type TipoDeCredenciado,
} from '@/nucleo/pessoaNatureza';
import { Badge } from '@/ui/base/badge';
import { cn } from '@/nucleo/utilitarios';

interface TipoPessoaBadgeProps {
  tipo: TipoDeCredenciado | string | null | undefined;
  /** Sigla curta (PF, PJ, Coop.), para coluna estreita. */
  compacto?: boolean;
  className?: string;
}

/**
 * Selo de natureza do credenciado: pessoa fisica, pessoa juridica ou cooperativa.
 *
 * A COOPERATIVA GANHA ICONE PROPRIO ainda que seja PJ para toda regra legal. E
 * escolha de leitura, nao de modelo: quem opera precisa distinguir a cooperativa de
 * relance, porque o rateio entre cooperados muda o que ela ve no demonstrativo.
 *
 * Sem token de cor proprio, de proposito. Natureza da pessoa nao e situacao — nao ha
 * "PJ bom" nem "PF ruim" —, e pintar isso gastaria o vocabulario de cor que os selos
 * de situacao usam para dizer se algo esta em ordem
 * (docs/DESIGN-SYSTEM.md, secao 5).
 */
export function TipoPessoaBadge({ tipo, compacto, className }: TipoPessoaBadgeProps) {
  const natureza = naturezaDaPessoa(tipo);

  if (!natureza) {
    return <span className="text-muted-foreground text-sm">—</span>;
  }

  const cooperativa = ehCooperativa(tipo);
  const Icone = natureza === 'PF' ? User : cooperativa ? Users : Building2;
  const rotulo = compacto
    ? natureza === 'PF'
      ? 'PF'
      : cooperativa
        ? 'Coop.'
        : 'PJ'
    : rotuloDoTipoDeCredenciado(tipo);

  return (
    <Badge variant="outline" className={cn('gap-1 font-normal', className)}>
      <Icone className="h-3 w-3" aria-hidden="true" />
      {rotulo}
    </Badge>
  );
}
